import { render, staticRenderFns } from "./follow_record_details.vue?vue&type=template&id=126232b9&"
import script from "./follow_record_details.vue?vue&type=script&lang=js&"
export * from "./follow_record_details.vue?vue&type=script&lang=js&"
import style0 from "./follow_record_details.vue?vue&type=style&index=0&id=126232b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports